// extracted by mini-css-extract-plugin
export default {"SearchPanel":"ph_a bhf_ea bhf_kb bhf_js bhf_a bhf_j bhf_sm bhf_sn","SearchPanel__icon":"ph_b bhf_vm bhf_hg bhf_ss bhf_uy","SearchPanel__input":"ph_c bhf_iz bhf_eb bhf_z"};